import { FETCH_PRODUCTS } from './actionTypes';
import axios from 'axios';

import { productsAPI } from '../util';

export const fetchProducts = (addToSort, selected, availables, filters, callback) => dispatch => {
  return axios
    .get(productsAPI)
    .then(res => {
      let { products } = res.data;
      let filteredProduct = [];
      let filterType = {};

      let tags = [];

      products.forEach(product => {
        if( Array.isArray(product.tags) ){
          product.tags.forEach(tag => {
            if( !tags.includes(tag) && !availables.includes(tag) ){
              tags.push(tag);
            }
          });
        }
      });

      tags.forEach(elem => {
        addToSort(elem);
      });

      if( selected.length > 0 ){
        products = products.filter(product => {
          if( Array.isArray(product.tags) ){
            let isAddable = false;
            product.tags.forEach(tag =>{
              if( selected.includes(tag) ){
                isAddable = true;
              }
            });

            if( isAddable ){
              return product;
            }
          }
        });
      }
      
      if( filters === "name" ){
        products.forEach((product, index) => {
          filterType[product.title] = index;
        });
  
        Object.keys(filterType).sort().forEach(value => {
          products.forEach(item => {
            if(item.title == value){
              filteredProduct.push(item);
            }
          });
        });
      }
      else if( filters === "lowToHigh" ){
        products.forEach((product, index) => {
          filterType[product.price] = index;
        });
        
        Object.keys(filterType).sort(function(a, b){return a - b}).forEach(value => {
          products.forEach(item => {
            if(item.price == value){
              filteredProduct.push(item);
            }
          });
        });
      }
      else if( filters === "highToLow" ){
        products.forEach((product, index) => {
          filterType[product.price] = index;
        });
        
        Object.keys(filterType).sort(function(a, b){return a - b}).reverse().forEach(value => {
          products.forEach(item => {
            if(item.price == value){
              filteredProduct.push(item);
            }
          });
        });
      }
      else{
        products.forEach((product, index) => {
          filterType[product.style] = index;
        });

        Object.keys(filterType).sort().forEach(value => {
          products.forEach(item => {
            if(item.style == value){
              filteredProduct.push(item);
            }
          });
        });
      }

      if (!!callback) {
        callback();
      }

      return dispatch({
        type: FETCH_PRODUCTS,
        payload: filteredProduct
      });
    })
    .catch(err => {
      console.log('Could not fetch products. Try again later.');
    });
};
